import { SET_TABLE_DATA } from "../../constants/dataTableConstants";

const initialState = {
  items: [],
  paginate: undefined,
  sumAmount: [],
  sumAmountFinal: []
};

const dataTableReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_TABLE_DATA:
      return {
        items: action.items,
        paginate: action.paginate,
        sumAmount: action.sumAmount ? action.sumAmount : [],
        sumAmountFinal: action.sumAmountFinal ? action.sumAmountFinal : []
      };
    default:
      return state;
  }
};

export default dataTableReducer;
